export default __webpack_public_path__ + "static/media/ic-sort.0edfe4d9.svg";